import React from 'react';
import { Container } from "@chakra-ui/react";

const Snapshot_QandA = () => {
    return (
        <Container maxW='100%'>
            
            
        </Container>
    );
};

export default Snapshot_QandA;